import * as S from './Footer.style';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import React from 'react';
import assets from 'assets';

const Footer = () => {
  return (
    <S.ContainerFooter>
      <S.ConteudoContainerLimit>
        <S.ColumContainerFooter>
          <img src={assets.images.logo} />
        </S.ColumContainerFooter>
        <S.ColumContainerFooter>
          <S.TituloColumContaianer> site </S.TituloColumContaianer>
          <S.Linkcomponent to="https://primaza.com.br/produtos/">Produtos</S.Linkcomponent>
          <S.Linkcomponent to="https://primaza.com.br/servicos/">Serviços</S.Linkcomponent>
          <S.Linkcomponent to="https://primaza.com.br/contato/">Contato</S.Linkcomponent>
          <S.Linkcomponent to="https://primaza.com.br/blog/">Blog</S.Linkcomponent>
        </S.ColumContainerFooter>

        <S.ColumContainerFooter>
          <S.TituloColumContaianer secundary>e-mail </S.TituloColumContaianer>
          <S.ListColumContainer
            onClick={() => {
              window.location.href = 'mailto:contato@primaza.com.br';
            }}
          >
            contato@primaza.com.br
          </S.ListColumContainer>
          <S.TituloColumContaianer secundary>orçamentos </S.TituloColumContaianer>
          <S.ListColumContainer>(55) 3375-8443</S.ListColumContainer>
        </S.ColumContainerFooter>

        <S.ColumContainerFooter>
          <S.TituloColumContaianer secundary> endereço </S.TituloColumContaianer>
          <S.ListColumContainer>Acesso a BR 285 | Panambi/RS</S.ListColumContainer>
          <S.TituloColumContaianer secundary> Pós-Venda </S.TituloColumContaianer>
          <S.ListColumContainer>(55) 3375-8443</S.ListColumContainer>
        </S.ColumContainerFooter>
        <S.ColumContainerFooter>
          <S.TituloColumContaianer secundary> Primaza nas Mídias Sociais </S.TituloColumContaianer>
          <S.ListColumContainer
            onClick={() => {
              window.location.href = 'https://instagram.com/primaza.br';
            }}
            secundary
          >
            <InstagramIcon />
            @primaza.br
          </S.ListColumContainer>
          <S.ListColumContainer
            onClick={() => {
              window.location.href = 'https://facebook.com/primaza.br';
            }}
            secundary
          >
            <FacebookIcon />
            Primaza
          </S.ListColumContainer>
        </S.ColumContainerFooter>
      </S.ConteudoContainerLimit>
      <S.VersionContainer> Versão 1.0.2 </S.VersionContainer>
    </S.ContainerFooter>
  );
};

export default Footer;
